import {EXTERNAL_APPEALS_STATUSES} from "@/utils/constants.js";

export class AdminExternalAppealModel {
    constructor(data = {}) {
        this.appealId = data.appealId ?? null;
        this.appealStatus = data.appealStatus ?? EXTERNAL_APPEALS_STATUSES.InfoNeeded;
        this.appealOutcome = data.appealOutcome ?? null;
        this.appealCategory = data.appealCategory ?? null;
        this.healthInsuranceCompany = data.healthInsuranceCompany ?? null;
        this.patientInsuranceId = data.patientInsuranceId ?? null;
        this.typeOfCoverage = data.typeOfCoverage ?? null;
        this.patientName = data.patientName ?? null;
        this.signature = data.signature ?? null;
        this.relationshipToPatient = data.relationshipToPatient ?? null;
        this.documents = data.documents ?? null;
        this.isExpedited = data.isExpedited ?? false;
        this.reviewOrganization = data.reviewOrganization ?? null;
        this.assignedInvestigator = data.assignedInvestigator ?? null;
        this.iroAt = data.iroAt ?? null;
        this.createdAt = data.createdAt ?? null;
        this.updatedAt = data.updatedAt ?? null;
    }
}
